export default function DonateXIcon({
  color,
  className,
}: {
  color?: string;
  className?: string;
}) {
  return (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      className={className}
      viewBox="0 0 1565.5 1566"
    >
      <path
        d="M801.8,1564.7V826.5l763.7,0.6c-4.3,69.2-16.7,125.6-16.7,125.6c-21.5,99-61.6,191.7-119,275.7
	s-129.3,154.9-213.7,210.9c-87.4,58-184.3,97.3-288.3,116.8C927.9,1556.1,829.4,1569.2,801.8,1564.7z"
      />
      <path
        d="M1552.9,641.7
	c-18.4-104.1-62-203.9-120-291.2c-56-84.4-127-156.3-210.9-213.7s-176.7-97.4-275.7-119C891.5,5.9,836.2-0.1,780.6,0v827.1h784.9
	l-0.7-85.1C1564.9,742.1,1561,687.5,1552.9,641.7z"
      />
      <path
        d="M0,740.8v-10.5c2.1-30.5,6-61,11.8-91.5
	c19.5-103.9,58.8-200.9,116.8-288.3c56-84.4,127-156.3,210.9-213.7s176.7-97.4,275.7-119C670,5.9,725.3-0.1,780.9,0v827.1H0L0,740.8
	L0,740.8z"
      />
      <path
        d="M808.7,827.1H0c2,33.4,6.1,66.8,12.3,100.1
	c19.5,103.9,58.7,200.9,116.5,288.3c55.9,84.4,126.7,156.3,210.4,213.7s176.3,97.4,275,119c54.5,11.9,109.6,17.8,164.9,17.8
	c9.8,0,19.7-0.2,29.5-0.6L808.7,827.1L808.7,827.1z"
      />
      <circle fill={color || "#000000"} cx="783.2" cy="782.5" r="737.8" />
      <path
        d="M783.5,634.3L553.8,346.4
	c-7.6-9.5-19.1-15-31.3-15.1l-225-0.1l364.4,455.4l121.6,152l232.6,290.7c7.7,9.6,19.3,15.1,31.6,15l221.2-2L905.2,786.7
	L783.5,634.3z"
      />
      <path
        d="M908.6,746.5c4.1,4.8,18.3,3.5,22.3-1.3
	l344.2-414.9l-216.4,0.1c-11.7,0-22.8,5.5-30.1,15.1L811.3,613.3c-3.5,4.3-3.4,10.5,0.2,14.8L908.6,746.5z"
      />
      <path
        d="M640.5,819.9c-6.3-7.6-18-7.7-24.4-0.1
	l-355.6,423.3l216.4-0.3c11.8,0.1,26.5-9.1,33.9-18.6l223.9-269.6c3.4-4.2,6.6-12.7,3.2-16.9L640.5,819.9z"
      />
    </svg>
  );
}
